import {
  pipelineColumnOptions,
  pipelineDefaultColumnVisibilityModel,
  pipelineDefaultSortDirection,
  pipelineDefaultSortKey,
  type PipelineSortDirection,
  type PipelineSortKey,
  type PipelineTableStatus,
  pipelineSortOptions,
  pipelineStatusOptions,
} from '@/features/pipelines/pages/pipelinesTableDefinition';
import { TableToolbar } from '@/features/shared/components/tableSystem/TableToolbar';
import type { CloneDateQuickFilter } from '@/features/shared/hooks/useCloneDateWindow';
import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { Dayjs } from 'dayjs';
import type { ReactElement } from 'react';

type PipelinesTableToolbarProps = {
  onDebouncedSearchChange: (value: string) => void;
  columnVisibilityModel: GridColumnVisibilityModel;
  onColumnVisibilityModelChange: (nextModel: GridColumnVisibilityModel) => void;
  sortKey: PipelineSortKey;
  sortDirection: PipelineSortDirection;
  onSortChange: (sortKey: PipelineSortKey, sortDirection: PipelineSortDirection) => void;
  filterStatuses: PipelineTableStatus[];
  onFilterStatusesChange: (next: PipelineTableStatus[]) => void;
  filterTags: string[];
  onFilterTagsChange: (next: string[]) => void;
  dateQuickFilter: CloneDateQuickFilter;
  onDateQuickFilterChange: (next: CloneDateQuickFilter) => void;
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  onFromDateChange: (next: Dayjs | null) => void;
  onToDateChange: (next: Dayjs | null) => void;
  availableTags: string[];
  summaryCount?: number | null;
};

export const PipelinesTableToolbar = (props: PipelinesTableToolbarProps): ReactElement => (
  <TableToolbar<PipelineSortKey, PipelineTableStatus>
    title="Pipelines"
    searchAriaLabel="Search pipelines, tags"
    defaultColumnVisibilityModel={pipelineDefaultColumnVisibilityModel}
    columnOptions={pipelineColumnOptions}
    defaultSortKey={pipelineDefaultSortKey}
    defaultSortDirection={pipelineDefaultSortDirection}
    sortOptions={pipelineSortOptions}
    statusOptions={pipelineStatusOptions}
    summarySingularLabel="pipeline"
    summaryPluralLabel="pipelines"
    {...props}
  />
);

export type { CloneDateQuickFilter };
